export default __webpack_public_path__ + "static/media/heart.582b8c76.svg";